import { parseParamsForURL } from 'services/utils/urlParams';
import http from 'services/utils/http';
import consts from 'services/metaData/consts';
import { subscribeToAngularEvent } from 'services/utils/angularUtils';

const apiName = 'providers';
const baseUrl = '/api/rest/v1/partners/mediationProviders';
const formatData = (data) => {
    const res = data.slice();
    const ssaProvider = {
        id: consts.PROVIDER_IDS.IRONSOURCE,
        name: consts.PROVIDER_NAMES.IRONSOURCE,
        displayName: consts.PROVIDER_NAMES.IRONSOURCE,
        availableAdUnit: ['rewardedVideo', 'interstitial', 'banner'],
        active: true
    };
    let tempIndex = 0;
    res.unshift(ssaProvider);
    const map = res.reduce((acc, adSource) => {
        acc[adSource.id] = { ...adSource };
        acc[adSource.id].indexInArray = tempIndex;
        if (adSource.availableAdUnit) {
            acc[adSource.id].availableAdUnit = {};
            for (let i = 0; i < adSource.availableAdUnit.length; i++) {
                acc[adSource.id].availableAdUnit[adSource.availableAdUnit[i]] = true;
            }
        }
        tempIndex += 1;
        return acc;
    }, {});
    return {
        map,
        arr: data
    };
};

export default {
    namespaced: true,
    state: {
        list: null,
        error: undefined,
        loading: true,
        subscribedToClearCacheEvent: false
    },
    mutations: {
        setLoading(state, isLoading) {
            state.loading = isLoading;
        },
        setProviders(state, providers) {
            state.list = providers;
            state.loading = false;
        },
        setError(state, error) {
            state.error = error;
        },
        setSubscribedToClearCacheEvent(state, subscribedToClearCacheEvent) {
            state.subscribedToClearCacheEvent = subscribedToClearCacheEvent;
        }
    },
    actions: {
        async fetch({ state, commit, rootGetters }, {
            refresh = false,
            filters = {}
        } = {}) {
            const params = parseParamsForURL(filters);
            const apiUrl = `${baseUrl}?${params}`;

            if (!state.subscribedToClearCacheEvent) {
                subscribeToAngularEvent('adSourcesClearCache', () => {
                    commit('cache/clearCache', { api: apiName }, { root: true });
                });
                commit('setSubscribedToClearCacheEvent', true);
            }

            if (!refresh) {
                const cachedResult = rootGetters['cache/getFromCache'](apiName, apiUrl);
                if (cachedResult) {
                    commit('setError', undefined);
                    commit('setProviders', cachedResult);
                    return;
                }
            }

            try {
                commit('setLoading', true);
                const resData = await http.get(apiUrl);
                const res = formatData(resData.data);
                commit('cache/set', {
                    api: apiName,
                    req: apiUrl,
                    data: res
                }, { root: true });
                commit('setProviders', res);
                commit('setError', undefined);
            } catch (err) {
                commit('setError', err.message);
            } finally {
                commit('setLoading', false);
            }
        }
    },
    getters: {
        getProviders: (state) => state.list,
        getAdSourcesLoading: (state) => state.loading
    }
};
